import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The ComparadorTradedAmounts component.
 */
const ComparadorTradedAmounts = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-Comparador-MontosTransados.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>
          Selecciona el tipo de distribución que deseas para los datos, puedes ver el monto transado en cada mes, su
          acumulativo anual o diferencia por porcentajes.
        </Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Eje correspondiente al tipo de distribución seleccionada.</Item>
        <Item>Información del mes.</Item>
        <Item>Eje correspondiente a todos los meses del año.</Item>
        <Item>Leyenda para los organismos compradores consultados.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default ComparadorTradedAmounts
